"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _Popup = require("../../components/Popup/Popup");

var _Popup2 = _interopRequireDefault(_Popup);

var _user = require("../../redux/modules/user");

var _helpersStylesIcons = require("./helpers-styles-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicWalletTermsPopup = function (_React$Component) {
  (0, _inherits3.default)(EpicWalletTermsPopup, _React$Component);

  function EpicWalletTermsPopup(props) {
    (0, _classCallCheck3.default)(this, EpicWalletTermsPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EpicWalletTermsPopup.__proto__ || (0, _getPrototypeOf2.default)(EpicWalletTermsPopup)).call(this, props));

    _this.handleAgreementCheck = function () {
      _this.setState(function (state) {
        return { isChecked: !state.isChecked };
      });
    };

    _this.handleContinue = function () {
      _this.props.dispatch((0, _user.acceptEpicWalletTerms)()).then(function (result) {
        if (result.success && !result.error) {
          _this.props.dispatch((0, _user.creditToEpicWallet)()).then(function (result) {
            _this.setState(result);
          });
        }
      });
    };

    _this.handleSuccess = function () {
      if (_this.state.success) {
        _this.props.onCloseYes();
        _this.props.router.push("/");
      }
    };

    _this.state = {
      isChecked: false,
      termsAccepted: false,
      error: null,
      success: false
    };
    return _this;
  }

  (0, _createClass3.default)(EpicWalletTermsPopup, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _Popup2.default,
        null,
        _react2.default.createElement(
          _Popup2.default.Header,
          null,
          _react2.default.createElement(
            "div",
            {
              className: (0, _helpersStylesIcons.boxStyles)({
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }) },
            _react2.default.createElement(
              "span",
              null,
              this.state.success ? "Success" : "Accept Epic Wallet Terms and Conditions"
            ),
            _react2.default.createElement(
              "span",
              {
                className: (0, _helpersStylesIcons.boxStyles)({ height: "24px", width: "24px", cursor: "pointer" }),
                onClick: this.props.onCloseYes },
              _react2.default.createElement(_helpersStylesIcons.CloseIconSvg, null)
            )
          )
        ),
        _react2.default.createElement(
          _Popup2.default.Content,
          null,
          this.state.success ? _react2.default.createElement(
            "p",
            null,
            "Your points have successfully been converted into Epic Wallet credit."
          ) : _react2.default.createElement(
            "p",
            null,
            "Before we can proceed with your point conversion request, please read and agree to the",
            " ",
            _react2.default.createElement(
              "a",
              {
                href: "https://www.epicgames.com/site/en-US/wallet-terms",
                className: _helpersStylesIcons.anchorStyles,
                target: "_blank" },
              "Epic Wallet Terms and Conditions"
            ),
            "."
          ),
          !this.state.success && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement("br", null),
            _react2.default.createElement(_Checkbox2.default, {
              label: "I have read and agree to the Epic Wallet Terms and Conditions",
              checked: this.state.isChecked,
              onChange: this.handleAgreementCheck,
              className: (0, _glamor.css)({
                "& label > span": {
                  fontSize: "14px",
                  lineHeight: "20px",
                  letterSpacing: "0px"
                }
              })
            }),
            this.state.error && _react2.default.createElement(
              "div",
              { className: (0, _helpersStylesIcons.boxStyles)({ display: "flex", gap: "16px", marginTop: "24px" }) },
              _react2.default.createElement(
                "div",
                {
                  className: (0, _helpersStylesIcons.boxStyles)({
                    "& svg > path": {
                      fill: "orange"
                    }
                  }) },
                _react2.default.createElement(_helpersStylesIcons.ErrorIconSvg, null)
              ),
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "p",
                  null,
                  this.state.error.message || this.state.error
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _Popup2.default.Footer,
          null,
          _react2.default.createElement(
            "div",
            {
              className: (0, _helpersStylesIcons.boxStyles)({ display: "flex", justifyContent: "flex-end", width: "100%" }) },
            _react2.default.createElement(_Button2.default, {
              small: true,
              mode: "secondary",
              label: this.state.success ? "Done" : "Continue",
              disabled: !this.state.isChecked,
              onClick: this.state.success ? this.handleSuccess : this.handleContinue,
              className: _helpersStylesIcons.buttonStylesPrimary
            })
          )
        )
      );
    }
  }]);
  return EpicWalletTermsPopup;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)()(EpicWalletTermsPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/EpicWalletTermsPopup.jsx
// module id = 2964
// module chunks = 0